export const scrollTo = (element, offset, behavior = 'smooth') => {
  if (element) {
    const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: yCoordinate + offset, behavior: behavior });
  }
};
